<template>
    <div id='quote_modal' class="modal">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Download quotes</p>
                <button class="delete" aria-label="close" @click="doClose()"></button>
            </header>
            <section class="modal-card-body">
                <div>All quotes were successfully submitted.</div>
                <div>You can download the quotes, go back and edit, or finish this session.</div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="doDownload()">
                    Download
                </button>
                <button class="button is-warning" @click="doEdit()">
                    Edit
                </button>
                <button class="button is-danger" @click="doFinish();">
                    Finish
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuoteModal",
    methods: {
        doFinish() {
            this.$emit('doFinish')
        },
        doClose() {
            this.$emit('doClose')
        },
        doDownload() {
            this.$emit('doDownload')
        },
        doEdit() {
            this.$emit('doEdit')
        }
    }
};
</script>
